import React, { useEffect, useState } from "react";
import { alertMessageState } from "src/atom/LoadingState";
import { useSetRecoilState } from "recoil";
import callApi from "src/services/Common/api";
import Select from "react-select";

const FieldsComponent = ({
  data,
  ifCityName,
  setFormData,
  type,
  validationErrors = {},
  edit = true,
}) => {
  const mapping = {
    Permanent: {
      altPhoneNumber: "altPhoneNumber",
      city: "city",
      cityName: "cityName",
      landlineContact: "landlineContact",
      mailingAddress: "mailingAddress",
      pincode: "pincode",
      stdCode: "stdCode",
      districtId: "districtId",
      stateId: "stateId",
      tehsilId: "tehsilId",
      cityName: "cityName",
      isOtherSelected: "isOtherSelected",
    },
    Office: {
      altPhoneNumber: "officeAltPhoneNumber",
      city: "officeCity",
      cityName: "officeCityName",
      landlineContact: "officeLandlineContact",
      mailingAddress: "officeMailingAddress",
      pincode: "officePincode",
      stdCode: "officeStdCode",
      districtId: "officeDistrictId",
      stateId: "officeStateId",
      tehsilId: "officeTehsilId",
      cityName: "officeCityName",
      isOtherSelected: "isOfficeOtherSelected",
    },
    Correspondance: {
      altPhoneNumber: "corrAltPhoneNumber",
      city: "corrCity",
      cityName: "corrCityName",
      landlineContact: "corrLandlineContact",
      mailingAddress: "corrMailingAddress",
      pincode: "corrPincode",
      stdCode: "corrStdCode",
      districtId: "corrDistrictId",
      stateId: "corrStateId",
      tehsilId: "corrTehsilId",
      cityName: "corrCityName",
      isOtherSelected: "isCorrOtherSelected",
    },
  };
  const [districts, setDistricts] = useState([{}]);
  const [tehsils, setTehsils] = useState([{}]);
  const [city, setCity] = useState([{}]);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const [states, setStates] = useState([]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  useEffect(() => {
    if (ifCityName != undefined && ifCityName != null) {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
    }
  }, [ifCityName]);

  const fetchDistricts = async (stateId) => {
    const responseData = await callApi(
      `/v1/api/districts/${stateId}`,
      "GET",
      null,
      true,
      setAlertMessage
    );
    if (responseData.success != false) {
      setDistricts(responseData.body);
    }
  };

  const fetchTehsils = async (districtId) => {
    const responseData = await callApi(
      `/v1/api/tehsils/${districtId}`,
      "GET",
      null,
      true,
      setAlertMessage
    );
    if (responseData.success != false) {
      setTehsils(responseData.body);
    }
  };

  const fetchStates = async () => {
    const responseData = await callApi(
      `/v1/api/states`,
      "GET",
      null,
      true,
      setAlertMessage
    );
    if (responseData.success != false) {
      setStates(responseData.body);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    if (data?.[mapping?.[type]?.stateId]) {
      fetchDistricts(data[mapping[type]?.stateId]);
    }
  }, [data?.[mapping[type]?.stateId]]);

  useEffect(() => {
    if (data?.[mapping?.[type]?.districtId]) {
      fetchTehsils(data[mapping[type]?.districtId]);
    }
  }, [data?.[mapping[type]?.districtId]]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      if (name === "stateId") {
        updatedData[mapping[type].stateId] = value;
        updatedData[mapping[type].districtId] = null;
        updatedData[mapping[type].tehsilId] = null;
      } else if (name === "districtId") {
        updatedData[mapping[type].districtId] = value;
        updatedData[mapping[type].tehsilId] = null;
      } else if (name === "tehsilId") {
        updatedData[mapping[type].tehsilId] = value;
      } else if (name === "city") {
        let filteredValue = value
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s{2,}/g, " ");
        if (filteredValue.startsWith(" ")) {
          filteredValue = filteredValue.substring(1);
        }

        updatedData[mapping[type].city] = filteredValue;
      } else {
        if (name == "cityName") {
          const cityId = updatedData[mapping[type].city];
          const ccoption =
            cityOptions?.find((option) => option.value === cityId).label ||
            null;
          if (ccoption == "Other") {
            setIsOtherSelected(true);
            updatedData[mapping[type].isOtherSelected] = true;
            updatedData[[mapping[type][name]]] = value;
          } else {
            setIsOtherSelected(false);
            updatedData[mapping[type].cityName] = null;
            updatedData[mapping[type].isOtherSelected] = false;
          }
        }
        updatedData[[mapping[type][name]]] = value;
      }
      return updatedData;
    });
  };

  const [error, setError] = useState("");
  const allowedSpecialCharacters = /^[a-zA-Z0-9.,/\- ]*$/;

  const handleChange = (e) => {
    const { value } = e.target;
    if (allowedSpecialCharacters.test(value)) {
      const trimmedValue = value.trim();
      if (value[0] === " " && !/[a-zA-Z]/.test(trimmedValue)) {
        setError("Input cannot start with a space and be empty of letters.");
      } else {
        setError("");
        handleInputChange(e);
      }
    }
  };

  const options = states?.map((state) => ({
    value: state.id,
    label: state.stateName,
  }));

  const districtOptions = districts?.map((district) => ({
    value: district.id,
    label: district.districtname,
  }));

  const tehsilOptions = tehsils?.map((tehsil) => ({
    value: tehsil.id,
    label: tehsil.tehsilName,
  }));

  const cityOptions = [
    ...city?.map((cities) => ({
      value: cities.id,
      label: cities.cityName,
    })),
  ];

  return (
    <>
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th scope="col" colSpan="4" style={{ textAlign: "center" }}>
              {type == "Office" && "Present Office Address"}
              {type == "Correspondance" && "Present Residential Address"}
              {type == "Permanent" && "Permanent Address"}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              colSpan={2}
              scope="row"
              style={{ width: "50%", textAlign: "right" }}
            >
              <p style={{ margin: "0", fontSize: "80%" }}>
                <b>
                  Mailing Address
                  <span style={{ color: "black" }}> *</span>
                </b>
              </p>
              {edit && (
                <p style={{ margin: "0", color: "blue" }}>
                  (Only .,/- special characters are allowed)
                </p>
              )}
            </td>
            <td colSpan={2}>
              <textarea
                className={`form-control ${
                  validationErrors[mapping[type]?.mailingAddress]
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Enter Mailing Address"
                id="mailingAddress"
                name="mailingAddress"
                value={
                  data?.[mapping[type]?.mailingAddress]
                    ? data?.[mapping[type]?.mailingAddress]
                    : ""
                }
                onChange={handleChange}
                rows="3"
                style={{ width: "100%" }}
                disabled={!edit}
                maxLength={50}
              ></textarea>
              {validationErrors[mapping[type]?.mailingAddress] && (
                <div className="invalid-feedback">
                  {validationErrors[mapping[type]?.mailingAddress]}
                </div>
              )}
            </td>
          </tr>
          <tr>
            <th
              scope="row"
              style={{ width: "25%", textAlign: "right", fontSize: "80%" }}
            >
              State
              <span style={{ color: "black" }}> *</span>
            </th>
            <Select
              name="stateId"
              onChange={(selectedOption) => {
                handleInputChange({
                  target: { name: "stateId", value: selectedOption?.value },
                });
              }}
              className={`form-control ${
                validationErrors[mapping[type]?.stateId] ? "is-invalid" : ""
              }`}
              value={
                options?.find(
                  (option) => option.value === data?.[mapping[type]?.stateId]
                ) || null
              }
              id="state"
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "100%",
                  height: "50px",
                  // fontSize: "80%",
                  fontWeight: "bold",
                }),
              }}
              isDisabled={!edit}
              placeholder="Select State..."
              isSearchable
              options={options}
            />
            {validationErrors[mapping[type]?.stateId] && (
              <div style={{ color: "#e55353" }} className="invalid-feedback">
                {validationErrors[mapping[type]?.stateId]}
              </div>
            )}

            <th
              scope="row"
              style={{ width: "25%", textAlign: "right", fontSize: "80%" }}
            >
              District
              <span style={{ color: "black" }}> *</span>
            </th>
            <Select
              name="districtId"
              onChange={(selectedOption) => {
                handleInputChange({
                  target: { name: "districtId", value: selectedOption?.value },
                });
              }}
              className={`form-control ${
                validationErrors[mapping[type]?.districtId] ? "is-invalid" : ""
              }`}
              value={
                districtOptions?.find(
                  (option) => option.value === data?.[mapping[type]?.districtId]
                ) || null
              }
              id="district"
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "100%",
                  height: "50px",
                  // fontSize: "80%",
                  fontWeight: "bold",
                }),
              }}
              isDisabled={!edit}
              placeholder="Select District..."
              isSearchable
              options={districtOptions}
            />
            {validationErrors[mapping[type]?.districtId] && (
              <div style={{ color: "#e55353" }} className="invalid-feedback">
                {validationErrors[mapping[type]?.districtId]}
              </div>
            )}
          </tr>
          <tr>
            <th
              scope="row"
              style={{ width: "25%", textAlign: "right", fontSize: "80%" }}
            >
              Tehsil
              <span style={{ color: "black" }}> *</span>
            </th>
            <Select
              name="tehsilId"
              onChange={(selectedOption) => {
                handleInputChange({
                  target: { name: "tehsilId", value: selectedOption?.value },
                });
              }}
              className={`form-control ${
                validationErrors[mapping[type]?.tehsilId] ? "is-invalid" : ""
              }`}
              value={
                tehsilOptions?.find(
                  (option) => option.value === data?.[mapping[type]?.tehsilId]
                ) || null
              }
              id="tehsil"
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "100%",
                  height: "50px",
                  // fontSize: "80%",
                  fontWeight: "bold",
                }),
              }}
              isDisabled={!edit}
              placeholder="Select Tehsil..."
              isSearchable
              options={tehsilOptions}
            />
            {validationErrors[mapping[type]?.tehsilId] && (
              <div style={{ color: "#e55353" }} className="invalid-feedback">
                {validationErrors[mapping[type]?.tehsilId]}
              </div>
            )}
            <th
              scope="row"
              style={{ width: "25%", textAlign: "right", fontSize: "80%" }}
            >
              City / Village
              <span style={{ color: "black" }}> *</span>
            </th>
            <td>
              <div>
                <input
                  type="text"
                  className={`form-control ${
                    validationErrors[mapping[type]?.city] ? "is-invalid" : ""
                  }`}
                  id="city"
                  placeholder="Enter City / Village"
                  name="city"
                  style={{ width: "100%", height: "30px", fontWeight: "bold" }}
                  value={data?.[mapping[type]?.city] || ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  disabled={!edit}
                  maxLength={30}
                />
                {validationErrors[mapping[type]?.city] && (
                  <div
                    style={{ color: "#e55353" }}
                    className="invalid-feedback"
                  >
                    {validationErrors[mapping[type]?.city]}
                  </div>
                )}
              </div>
            </td>
          </tr>
          {isOtherSelected ? (
            <>
              <tr>
                <th scope="row" style={{ width: "25%", textAlign: "right" }}>
                  Enter City/Village name
                  <span style={{ color: "black" }}> *</span>
                </th>
                <td>
                  <div>
                    <input
                      name="cityName"
                      id="cityName"
                      type="text"
                      className={`form-control ${
                        validationErrors[mapping[type]?.cityName]
                          ? "is-invalid"
                          : ""
                      }`}
                      disabled={!edit}
                      placeholder="Enter other city"
                      value={data?.[mapping[type]?.cityName] || ""}
                      onChange={(e) => {
                        handleInputChange({
                          target: { name: "cityName", value: e.target.value },
                        });
                      }}
                    />
                    {validationErrors[mapping[type]?.cityName] && (
                      <div className="invalid-feedback">
                        {validationErrors[mapping[type]?.cityName]}
                      </div>
                    )}
                  </div>
                </td>
                <th scope="row" style={{ width: "25%", textAlign: "right" }}>
                  Pin Code
                  <span style={{ color: "black" }}> *</span>
                </th>
                <td>
                  <input
                    type="text"
                    className={`form-control ${
                      validationErrors[mapping[type]?.pincode]
                        ? "is-invalid"
                        : ""
                    }`}
                    id="pincode"
                    placeholder="Enter pincode"
                    name="pincode"
                    style={{
                      width: "100%",
                      height: "30px",
                      fontWeight: "bold",
                    }}
                    value={data?.[mapping[type]?.pincode] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    disabled={!edit}
                    maxLength={6}
                  />
                  {validationErrors[mapping[type]?.pincode] && (
                    <div className="invalid-feedback">
                      {validationErrors[mapping[type]?.pincode]}
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <th scope="row" style={{ width: "25%", textAlign: "right" }}>
                  Alternate Contact Number
                </th>
                <td>
                  <input
                    type="text"
                    className={`form-control`}
                    id="altPhoneNumber"
                    placeholder="Enter alternate mobile number"
                    name="altPhoneNumber"
                    style={{
                      width: "100%",
                      height: "30px",
                      fontWeight: "bold",
                    }}
                    value={data?.[mapping[type]?.altPhoneNumber] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    disabled={!edit}
                    maxLength={10}
                  />
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <th
                  scope="row"
                  style={{ width: "25%", textAlign: "right", fontSize: "80%" }}
                >
                  Pin Code
                  <span style={{ color: "black" }}> *</span>
                </th>
                <td>
                  <input
                    type="text"
                    className={`form-control ${
                      validationErrors[mapping[type]?.pincode]
                        ? "is-invalid"
                        : ""
                    }`}
                    id="pincode"
                    placeholder="Enter pincode"
                    name="pincode"
                    style={{
                      width: "100%",
                      height: "30px",
                      fontWeight: "bold",
                    }}
                    value={data?.[mapping[type]?.pincode] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    disabled={!edit}
                    maxLength={6}
                  />
                  {validationErrors[mapping[type]?.pincode] && (
                    <div className="invalid-feedback">
                      {validationErrors[mapping[type]?.pincode]}
                    </div>
                  )}
                </td>
                <th
                  scope="row"
                  style={{ width: "25%", textAlign: "right", fontSize: "80%" }}
                >
                  Alternate Contact Number
                </th>
                <td>
                  <input
                    type="text"
                    className={`form-control`}
                    id="altPhoneNumber"
                    placeholder="Enter alternate mobile number"
                    name="altPhoneNumber"
                    style={{
                      width: "100%",
                      height: "30px",
                      fontWeight: "bold",
                    }}
                    value={data?.[mapping[type]?.altPhoneNumber] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    disabled={!edit}
                    maxLength={10}
                  />
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </>
  );
};

export default FieldsComponent;
